import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PopupData } from '../training-parameter-template/training-parameter-template.component';
import { DomSanitizer } from '@angular/platform-browser';
import { StaticAuditTrailComponent } from 'src/app/support/static-audit-trail/static-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-training-certificate-template',
  templateUrl: './training-certificate-template.component.html',
  styleUrls: ['./training-certificate-template.component.scss'],
})

export class TrainingCertificateTemplateComponent implements OnInit {
  isProcessing = true;
  _temp: any = {};
  certificateTemplateList: any = [];
  certificateTemplateData: any = {};
  previewData: any;
  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar, private readonly datePipe: DatePipe,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef, public sanitizer: DomSanitizer) { }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.certificateTemplateList.length, page, this.perPage, targetPage);
    this.pagedItems = this.certificateTemplateList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }
    if (this.certificateTemplateList.length > 0) {
      this.pager = this.paginationService.getPager(this.certificateTemplateList.length, page, this.perPage, targetPage);
      this.pagedItems = this.certificateTemplateList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  getCall() {
    this.certificateTemplateList = [];
    this.isProcessing = true;
    this.appService.getTrainingCertificateTemplates().subscribe({
      next: (data: any) => {
        this.isProcessing = false;
        this.certificateTemplateList = data;
        this.collectionSize = this.certificateTemplateList.length;
        this.calculateTotalPages = this.collectionSize / this.perPage;
        this.pager.totalPages = undefined;
        this.setPage(1, 0);

      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });

  }

  ngOnInit() {
    this.getCall();
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.certificateTemplateList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.certificateTemplateList.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  searchValue: any;
  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pager = this.paginationService.getPager(this.certificateTemplateList.length, 1, this.perPage, 0);
      this.pagedItems = this.certificateTemplateList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {

      if (this.certificateTemplateList == undefined) {
        return this.certificateTemplateList;
      }
      if (!this.certificateTemplateList.length) {
        return this.certificateTemplateList;
      }
      if (filter) {
        this.certificateTemplateList = this.certificateTemplateList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });

      } else {
        this.certificateTemplateList = this.certificateTemplateList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedOrSearch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.certificateTemplateList.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  parentCheckBox: boolean = false;
  childCheckBox: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBox = true;
      for (const element of this.certificateTemplateList) {
        element.childCheckBox = true;
      }
    } else {
      this.childCheckBox = false;
      for (const element of this.certificateTemplateList) {
        element.childCheckBox = false;
      }
    }
  }

  previousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.certificateTemplateList[this.previousSelectedValue].childCheckBox = false;
      }
      list.childCheckBox = true;
    } else {
      list.childCheckBox = false;
    }
    this.previousSelectedValue = idx;
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    });
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }

  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('previewPopup', { static: true }) previewPopup: TemplateRef<any>;
  @ViewChild('notePopup', { static: true }) notePopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visiblePreviewPopup: MatDialogRef<TemplateRef<any>>;
  visibleNotePopup: MatDialogRef<TemplateRef<any>>;

  notePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  previewPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '100px' },
  };

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multipleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
  };
  selectedRepeatIntervalUnit: any = [];
  selectedRepeatIntervalUnitDisplayExp: any = [];
  selectedRepeatIntervalUnitValueExp: any = [];
  repeatIntervalUnitDropdown: any = [];



  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;
  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create Training Certificate Template";
    this.certificateTemplateData = {};
    this.certificateTemplateData.templateName = '';
    this.certificateTemplateData.certificateTemplateData = '';
    this.certificateTemplateData.isDefaultWithscoreTemplate = 'N';
    this.certificateTemplateData.isDefaultWithscoreTemplate1 = false;
    this.certificateTemplateData.isDefaultWithoutscoreTemplate = 'N';
    this.certificateTemplateData.isDefaultWithoutscoreTemplate1 = false;
    this.certificateTemplateData.updateReason = '';
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  previousData: any;

  positionValue: any = 1;
  openEditPopup(editRowData: any, editFlag: boolean) {
    this.isProcessing = true;
    this.previousData = editRowData;
    this.visibleReasonForUpdateField = true;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = "Update Training Certificate Template";

    this.appService.getTrainingCertificateTemplateById(editRowData.templateId).subscribe((response: any) => {
      this.certificateTemplateData = response[0];
      this.certificateTemplateData.isDefaultWithscoreTemplate1 = this.certificateTemplateData.isDefaultWithscoreTemplate == "Y";
      this.certificateTemplateData.isDefaultWithoutscoreTemplate1 = this.certificateTemplateData.isDefaultWithoutscoreTemplate == "Y";
      this.certificateTemplateData.updateReason = '';
      this.isProcessing = false;
    })
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  refreshGridData() {
    this.getCall();
  }

  addAndEditFunction(add_edit_template: any) {

    const validations = [
      { condition: !add_edit_template.templateName, id: 'template-name' },
      { condition: !add_edit_template.template, id: 'template' },
      { condition: this.operationFlag == 'EDIT' && !add_edit_template.updateReason, id: 'update-reason' }
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
    } else {
      this.isProcessing = true;

      const obj = { ...add_edit_template };

      if (this.operationFlag !== 'EDIT') {
        delete obj.updateReason;
      }
      const data = {
        ...obj,
        isDefaultWithscoreTemplate: obj.isDefaultWithscoreTemplate1 ? 'Y' : 'N',
        isDefaultWithoutscoreTemplate: obj.isDefaultWithoutscoreTemplate1 ? 'Y' : 'N',
      }

      if (this.operationFlag == 'ADD') {
        this.appService.createTrainingCertificateTemplate(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.getCall();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {

        const modifiedData = {
          ...data,
          templateId: this.previousData.templateId
        }
        delete modifiedData.createdOn;
        delete modifiedData.updatedOn;
        this.appService.updateTrainingCertificateTemplate(modifiedData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.getCall();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteTrainingCertificate: any;
  openDeletePopup(deleteRowData: any) {
    console.log(deleteRowData);
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Training Certificate Template";
    this.deleteTrainingCertificate = deleteRowData;
    if (this.certificateTemplateData.deleteReason != undefined) {
      this.certificateTemplateData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteFunction(deletingTemplate: any) {
    if (deletingTemplate.deleteReason) {
      this.isProcessing = true;

      const data = {
        templateId: this.deleteTrainingCertificate.templateId,
        templateName: this.deleteTrainingCertificate.templateName,
        deleteReason: deletingTemplate.deleteReason,
      }

      this.appService.deleteTrainingCertificateTemplate(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.getCall();
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      const field = document.getElementById('delete-reason-validation') as HTMLInputElement;
      field.style.color = 'red';
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  @ViewChild('angularEditor', { static: true }) angularEditor: TemplateRef<any>;
  visibleAngularEditor: MatDialogRef<TemplateRef<any>>;

  angularEditorConfig = {
    width: '100%',
    height: 'auto',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '30px' },
  };

  editorTitle: string = '';
  editorNgModel: string = '';
  openEditor(title: string, value: string) {
    this.editorTitle = title;
    this.editorNgModel = value;
    this.visibleAngularEditor = this.dialog.open(this.angularEditor, this.angularEditorConfig);
  }

  disabled: EditorConfig = {
    buttons: [],
  };

  enabled: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  cancelAngularEditor() {
    this.visibleAngularEditor.close();
  }

  previewTemplate(value: any) {
    this.previewData = this.sanitizer.bypassSecurityTrustHtml(value);
    this.visiblePreviewPopup = this.dialog.open(this.previewPopup, this.previewPopupConfig);
  }

  cancelPreviewFunction() {
    this.visiblePreviewPopup.close();
  }

  clickToGetNote() {
    this.visibleNotePopup = this.dialog.open(this.notePopup, this.notePopupConfig);
  }

  cancelNote() {
    this.visibleNotePopup.close();
  }

  auditTrail: any = {};

  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;

  openAuditTrail(viewType: any, certificate: any) {
    this.message.tableOrView_Name = "TMS_TRAINING_CERTIFICATE_TEMPLATE_AU_VW";
    this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,TEMPLATE_NAME,TEMPLATE,IS_DEFAULT_WITHSCORE_TEMPLATE,IS_DEFAULT_WITHOUTSCORE_TEMPLATE,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON,DELETED_BY_USER,DELETED_REASON";
    this.message.columnList_UI = "Created Timestamp,End Timestamp,Action,Template Name,Template,Is Default with Score Template,Is Default without Score Template,Created On,Created By User,Updated On,Updated By User,Update Reason,Deleted By,Deleted Reason";
    this.message.whereClause_AU = viewType == 'overAll' ? "" : " AND TEMPLATE_ID = " + certificate.templateId;
    this.message.columnList_Report = "Created Timestamp,End Timestamp,Action,Template Name,Template,Is Default with Score Template,Is Default without Score Template,Created On,Created By User,Updated On,Updated By User,Update Reason,Deleted By,Deleted Reason";
    this.message.whereClause_Report = viewType == 'overAll' ? "" : " WHERE TEMPLATE_ID = " + certificate.templateId;
    this.message.report_And_Popup_Name = "Training Certificate Template Audit Trail";
    this.staticAuditTrailComponent.triggerTrail(certificate);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string) {
    this.excelPdf.tableOrView_Name = "TMS_TRAINING_CERTIFICATE_TEMPLATE_VW";
    this.excelPdf.columnList_DB = "TEMPLATE_NAME,IS_DEFAULT_WITHSCORE_TEMPLATE,IS_DEFAULT_WITHOUTSCORE_TEMPLATE,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON";
    this.excelPdf.columnList_Report = "Template Name,Is Default with Score Template,Is Default without Score Template,Created On,Created By User,Updated On,Updated By User,Update Reason";
    this.excelPdf.whereClause_Report = '';
    this.excelPdf.reportType = 'Static';
    this.excelPdf.reportName = 'Training Certificate Template Report';
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdfComponent.openReportPopup(reportType);
  }

  columnSearch(column: string, event: Event, dataTYpe: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.certificateTemplateList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.certificateTemplateList.filter((item: any) => {
        const columnValue = item[column];
        if (dataTYpe === 'd') {
          if (columnValue == null) {
            return false;
          }

          const formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
          return formattedDate?.toString().toLowerCase().includes(filter) ?? false;
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }

}
